"use strict";

var get = require('../getValueOfKeyMatching');

function TableNumbers(params) {
  var quantity = get(params, /tableNumbers/);
  var product_size = get(params, /tableSize/);
  this.tableNumbers.add({
    quantity: quantity,
    product_size: product_size
  });
}

module.exports = TableNumbers;